import { BaseXYAxisChartOptions, LegendOptions } from '@sprinklr/stories/hyperspaceWidgets/types';
import { observable } from 'mobx';
import { WidgetOptionsImpl } from 'models/Widget/WidgetOptions';
import { LegendOptionsImpl } from '../options';

import { HyperSpaceAreaChartWidgetOptions } from './types';

export class HyperSpaceAreaChartWidgetOptionsImpl extends WidgetOptionsImpl
    implements HyperSpaceAreaChartWidgetOptions {
    @observable baseXYChartOptions: HyperSpaceAreaChartWidgetOptions['baseXYChartOptions'] = {
        grid: {
            enabled: false,
        },
        fill: {
            type: 'solid',
            opacity: 70,
            gradient: { to: 50, from: 10 },
        },
        xAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
        yAxis: {
            ticks: {
                enabled: true,
                formats: {
                    numberFormat: {
                        decimals: 0,
                        useShortened: true,
                    },
                    dateFormat: {
                        autoFormat: true,
                        formatString: 'dd MMM',
                    },
                },
                //TODO: how should we actually set initial value
                numTicks: 5,
            },
            enabled: true,
            label: {
                enabled: true,
                size: 50,
            },
            line: {
                enabled: false,
                stroke: '',
                strokeWidth: 1,
            },
        },
    };
    @observable zeroFill = true;
    @observable legend: LegendOptions = new LegendOptionsImpl();
    @observable metaInfoOptions: HyperSpaceAreaChartWidgetOptions['metaInfoOptions'] = {
        color: {
            enabled: false,
            type: 'fill',
        },
    };
}
